// components/message/message.component.jsx
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Avatar from "../retro/avatar/avatar.component";
import { getUserDataWithId } from "../../firebase/firebase.utils";
import "./message.styles.scss";

const getTimeAgo = (created) => {
  const date = created?.toDate ? created.toDate() : new Date(created);
  if (Number.isNaN(date.getTime())) return "?";
  const now = new Date();
  const minutes = Math.floor(Math.max(0, now - date) / 60000);
  if (minutes < 1) return "Just now";
  if (minutes < 60) return `${minutes}m ago`;
  const time = date.toLocaleTimeString(undefined, {
    hour: "numeric",
    minute: "2-digit",
  });
  if (date.toDateString() === now.toDateString()) return time;
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  if (date.toDateString() === yesterday.toDateString())
    return `Yesterday, ${time}`;
  const days = Math.floor((now - date) / 86400000);
  if (days < 7)
    return `${date.toLocaleDateString(undefined, { weekday: "short" })}, ${time}`;
  return `${date.toLocaleDateString(undefined, { month: "short", day: "numeric", ...(date.getFullYear() !== now.getFullYear() ? { year: "numeric" } : {}) })}, ${time}`;
};
const Message = ({ msg }) => {
  const reduxUser = useSelector((state) =>
    state.user.users?.find((user) => user.uid === msg.from),
  );
  const [fetchedUser, setFetchedUser] = useState(null);
  const created = msg.created ?? msg.createdAt;
  const [time, setTime] = useState(() => getTimeAgo(created));
  const user = reduxUser || fetchedUser;
  const navigate = useNavigate();
  useEffect(() => {
    if (reduxUser || !msg.from || msg.moderationHidden) return;
    let isActive = true;
    setFetchedUser(null);
    getUserDataWithId(msg.from)
      .then((data) => {
        if (isActive) setFetchedUser(data);
      })
      .catch((error) => console.error("Could not load message user:", error));
    return () => {
      isActive = false;
    };
  }, [msg.from, reduxUser, msg.moderationHidden]);
  useEffect(() => {
    const updateTime = () => setTime(getTimeAgo(created));
    updateTime();
    const interval = setInterval(updateTime, 60000);
    return () => clearInterval(interval);
  }, [created]);
  if (msg.moderationHidden === true)
    return (
      <div className="message">
        <div className="message__msg">
          <p role="status" style={{ fontStyle: "italic" }}>
            This message was removed by moderation.
          </p>
          <small>{time}</small>
        </div>
      </div>
    );
  return (
    <div className="message">
      <button
        className="message__avatar"
        type="button"
        disabled={!user?.uid}
        onClick={() => {
          if (user?.uid) navigate(`/profile/${user.uid}`);
        }}
      >
        <Avatar user={user} src={user?.imageUrl} size={38} tiny />
      </button>
      <div className="message__msg">
        <div className="message__user">
          <div className="message__user-name">
            <p>
              <b>{user?.userName}</b>
            </p>
          </div>
          <div className="message__user-time">
            <p
              title={(() => {
                const date = created?.toDate
                  ? created.toDate()
                  : new Date(created);
                return Number.isNaN(date.getTime())
                  ? ""
                  : date.toLocaleString(undefined, {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                      hour: "numeric",
                      minute: "2-digit",
                    });
              })()}
            >
              {time}
            </p>
          </div>
        </div>
        <p>{msg.message}</p>
      </div>
    </div>
  );
};
export default Message;
